import { observer } from 'mobx-react-lite';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/common/Accordion';
import { ChevronDownIcon, TicketPercentIcon, UserRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/hooks/useStore';
import { useEffect } from 'react';
import { flowResult, toJS } from 'mobx';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';
interface PetOwnerListPopupProps {
    promotionId: number
}

export default observer(function PetOwnerListPopup({ promotionId }: PetOwnerListPopupProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const {
        modalStore: { showAlertModal, showModal, hideModal },
        promotionStore: { dataPetOwnerListDetail, getDataPetOwnerListDetail }
    } = useStore();

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        await flowResult(getDataPetOwnerListDetail({ id: promotionId }));
    };

    return (
        <>
            <div className='max-h-[500px] overflow-y-auto'>
                {
                    dataPetOwnerListDetail?.data && dataPetOwnerListDetail?.data.length > 0 && dataPetOwnerListDetail?.data.map((item, index) => (
                        <>
                            <Accordion type='multiple' key={index}>
                                <AccordionItem value='owner-a'>
                                    <AccordionTrigger className='bg-[#F2F2F2]'>
                                        <div className='flex justify-between w-full'>
                                            <div
                                                className='flex items-center pl-3 hover:underline'
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(`${ROUTES.userManagement.href}/${item.code}`);
                                                    hideModal();
                                                }}
                                            >
                                                <UserRoundIcon />
                                                <div className='pl-2'>{item.fullName}</div>
                                            </div>
                                            <div className='flex items-center text-[14px]'>
                                                <div className='mr-1'>{t('words_title.used1')}</div>
                                                <div className='text-green-600'>
                                                    {item?.appointments?.length ? item?.appointments?.length : 0}
                                                </div>
                                                <div className='mx-1'>
                                                    <TicketPercentIcon className='text-green-600' />
                                                </div>
                                                <div className='mr-5'>{t('words_title.used2')}</div>
                                            </div>
                                        </div>
                                    </AccordionTrigger>
                                    <AccordionContent>
                                        {/* Nội dung danh sách lịch hẹn */}
                                        <div className='w-full max-w-4xl mx-auto border rounded-b-md overflow-hidden'>
                                            {item?.appointments && item?.appointments.length > 0 && item?.appointments.map((booking, index) => (
                                                <div
                                                    key={index}
                                                    className='flex justify-between items-center px-4 py-3 border-b last:border-none md:text-base'
                                                >
                                                    <div className='flex items-center gap-2'>
                                                        <span className='text-gray-500 text-[14px] font-normal'>{t('words_title.appointment_id')}</span>
                                                        <span className='font-medium text-black text-[15px]'>{booking.code}</span>
                                                    </div>
                                                    <div className='flex items-center gap-2'>
                                                        <span className='text-gray-500 text-[14px]'>{t('words_title.promotion_created_date')}</span>
                                                        <span className='text-black text-[15px]'>{booking?.timeUsed ? moment(booking?.timeUsed).format('DD/MM/YYYY hh:mm:ss A') : '--'}</span>
                                                    </div>
                                                    <div
                                                        className='text-[#9A6051] hover:underline whitespace-nowrap cursor-pointer text-[15px]'
                                                        onClick={() => {
                                                            navigate(`${ROUTES.appointmentManagement.href}/${booking.code}`);
                                                            hideModal();
                                                        }}
                                                    >
                                                        {t('button.pet_owner_list')}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </AccordionContent>
                                </AccordionItem>
                            </Accordion>
                        </>
                    ))
                }
            </div>

            <div className='bg-white rounded-t-[4px] p-4 mt-3 border-t-[1px] mx-[-16px]'>
                <div className='flex justify-center'>
                    <button
                        type='button'
                        className='bg-[#EBEBEB] text-[#000] cursor-pointer w-[200px] h-[40px] leading-[40px] text-center rounded-sm mr-[30px]'
                        onClick={() => {
                            hideModal();
                        }}
                    >
                        {t('words_title.cancel')}
                    </button>
                </div>
            </div>
        </>
    );
});
